export enum SHIPMENT_TYPE {
  MANUAL = 0,
  AUTOMATICO = 1,
}

export const ShipmentTypeString = {
  [SHIPMENT_TYPE.MANUAL]: 'Manual',
  [SHIPMENT_TYPE.AUTOMATICO]: 'Automático',
};
